export default "__VITE_ASSET__DdOIeD63__"